// extracted by mini-css-extract-plugin
module.exports = {"singleBox":"SingleBox_singleBox__qJVr6"};